import { Injectable } from '@angular/core';
import { AuthenticatedContext } from '../models/authenticated-context';
import { Observable, Subscriber } from 'rxjs';

class AuthData extends AuthenticatedContext {
  channel: string;
  user: any;
}

@Injectable({
  providedIn: 'root'
})
export class ConnectService {

  private _observers: Map<string, Subscriber<AuthenticatedContext>> = new Map<string, Subscriber<AuthenticatedContext>>();

  constructor() { 
    this.initEventListener();
  }

  private initEventListener() {
    window.addEventListener("message", (ev) => {
      if (ev.origin !== location.origin) return;

      switch (ev.data.type) {
        case "connect-success": return this.onConnectSuccess(ev.data.data);
        case "connect-failure": return this.onConnectFailed(ev.data.data);
      }
    });
  }

  private onConnectSuccess(authData: AuthData) {
    if (!authData) {
      console.error(`Setup data is not available.`);
      return;
    }
    if (!authData.channel) {
      console.error(`channel is not available.`);
      return;
    }    
    if (!authData.user) {
      console.error(`user is not available.`);
      return;
    }

    if (!this._observers.has(authData.channel)) {
      console.debug(`No resolver is available for ${authData.channel}`);
      return;
    }

    const observer = this._observers.get(authData.channel);
    observer.next(authData);
  }

  private onConnectFailed(authData: AuthData) {
    if (!authData) {
      console.error(`Setup data is not available.`);
      return;
    }
    if (!authData.channel) {
      console.error(`channel is not available.`);
      return;
    }

    if (!this._observers.has(authData.channel)) {
      console.debug(`No resolver is available for ${authData.channel}`);
      return;
    }

    const observer = this._observers.get(authData.channel);
    observer.error(new Error(`Unable to authorize from ${authData.channel}`));
  }

  authorize(channelName: string): Observable<AuthenticatedContext> {
    if (this._observers.has(channelName)) {
      const observer = this._observers.get(channelName);
      observer.unsubscribe();
      this._observers.delete(channelName);
    }


    let regionId = 0;
    const regionIdUSA = 1;
    const regionIdEU = 2;
    let savedCredential = sessionStorage.getItem('credential');
    if (savedCredential) {
      const credential = JSON.parse(savedCredential);
      regionId = credential.region.id;
    }

    return new Observable(observer => {
      this._observers.set(channelName, observer);

      switch (regionId) {
        case regionIdUSA:
          window.open(`/connect/${channelName}/usa`);
          break;
        case regionIdEU:
          window.open(`/connect/${channelName}/eu`);
          break;
        default:
          //TODD:
          break;
      }

    });
  }
}
